<template>
  <section class="form__content">
    <h3>5. {{ $t('moreInformation.title') }}</h3>

    <v-menu ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-form v-model="formValidation">
          <v-text-field :value="arrivalDateHuman"
                        :label="$t('datesOfStay.arrivalDateLabel')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        required
                        :rules="[v => !!v || $t('error.required')]"
          />
        </v-form>
      </template>
      <v-date-picker ref="picker"
                     :value="arrivalDate"
                     @change="onSelectArrivalDate"
                     :min="new Date().toISOString().substr(0, 10)"
      />
    </v-menu>

    <v-textarea :label="$t('moreInformation.informationMessage')"
                :value="informationMessage"
                @input="$emit('update:informationMessage', $event)"
    />
  </section>
</template>

<script>
export default {
  name: 'SepMoreInformations',

  props: {
    valid: {
      required: true,
    },
    arrivalDate: {
      required: true,
    },
    informationMessage: {
      required: true,
    },
  },

  data: () => ({
    formValidation: false,
    menu: false,
  }),

  computed: {
    arrivalDateHuman () {
      return this.arrivalDate
             ? (new Date(this.arrivalDate)).toLocaleDateString(navigator.language)
             : ''
    },
  },

  watch: {
    formValidation () {
      this.$emit('update:valid', this.formValidation)
    },
  },

  methods: {
    onSelectArrivalDate (event) {
      this.menu = false
      this.$emit('update:arrivalDate', event)
    },
  },
}
</script>
